var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _g2, _g3, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _rect3, _rect4, _path114, _path115, _rect5, _path116, _path117, _path118, _rect6, _rect7, _path119, _path120, _path121, _rect8, _rect9, _path122, _path123, _path124, _path125, _path126, _path127, _path128;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "img_splash_aniimation",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278.319,
    height: 267.771,
    viewBox: "0 0 278.319 267.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17380",
    "data-name": "Rectangle 17380",
    width: 278.319,
    height: 267.771,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17370",
    "data-name": "Rectangle 17370",
    width: 72.099,
    height: 10.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17371",
    "data-name": "Rectangle 17371",
    width: 70.809,
    height: 28.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17372",
    "data-name": "Rectangle 17372",
    width: 71.734,
    height: 20.931,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8187",
    "data-name": "Group 8187",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10282",
    "data-name": "Path 10282",
    d: "M199.8,379.219H235.8a35.994,35.994,0,1,1,71.988,0H343.78V307.231H199.8Z",
    transform: "translate(-72.594 -111.626)",
    fill: "#fd734e",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10283",
    "data-name": "Path 10283",
    d: "M253.716,374.683l2.411,14.268-1.049,14.211h25.756l-.2-3.106a7.881,7.881,0,0,0-3.693-6.186l-7.2-4.494-1.1-16.734Z",
    transform: "translate(-92.182 -135.392)",
    fill: "#333533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10284",
    "data-name": "Path 10284",
    d: "M144.1,74.728a13.28,13.28,0,0,1,8.09,8.107c1.908,5.6,1.133,6.514,1.133,6.514l-9.488.708Z",
    transform: "translate(-52.258 -27.151)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10285",
    "data-name": "Path 10285",
    d: "M143.475,90.127l.275-15.865.28.084a13.62,13.62,0,0,1,8.236,8.248c1.895,5.56,1.18,6.626,1.092,6.729l-.06.071-.093.006Zm.709-15.257-.256,14.778,9.119-.681c.1-.3.341-1.7-1.2-6.23a13.16,13.16,0,0,0-7.662-7.867",
    transform: "translate(-52.128 -26.981)",
    fill: "#333533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10286",
    "data-name": "Path 10286",
    d: "M266.139,176.013,278.8,225.7l12.254,56.164,5.446,3.4,14.924-2.041,1.848-5.545-10.192-70.816L285.156,126.53l-23.291,18.175Z",
    transform: "translate(-95.143 -45.972)",
    fill: "#ffd447"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10287",
    "data-name": "Path 10287",
    d: "M234.8,155.969l-3.541,25.823,4.425,52.079,5.933,59.229,4.39,5.314,14.866-1.231,2.042-6.467V235.347l-.735-43.68.52-15.25-1.387-22.7Z",
    transform: "translate(-84.024 -55.85)",
    fill: "#ffd447"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10288",
    "data-name": "Path 10288",
    d: "M279.631,15.95a18.712,18.712,0,0,0,1.8,9.97c2.522,5.285,6.366,6.486,6.606,8.888s-2.883,2.042-.961,4.445,2.763,1.921,2.522,3.243-3.364,3.844-3.364,3.844-6.606,2.642-11.17-.961-1.081-12.732-1.081-12.732l.24-16.936Z",
    transform: "translate(-99.085 -5.708)",
    fill: "#333533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10289",
    "data-name": "Path 10289",
    d: "M240.4,22.34a3.337,3.337,0,0,1-.721,4.2c-2.1,2.1-.721,3.844-2.222,6.366s-4.445,3.6-4.445,5.465,1.441,2.462.9,4.024-.6,2.463,0,3.183a9.317,9.317,0,0,0,6.066,3c3.243.24,8.948-1.021,8.948-1.021s3.663-6.666,3-12.972-3.963-15.014-3.963-15.014-7.267.9-7.567,2.763",
    transform: "translate(-84.662 -7.113)",
    fill: "#333533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10290",
    "data-name": "Path 10290",
    d: "M250.374,55.144a6.275,6.275,0,0,0,2.432-2.342c1.172-1.8.991-7.117.991-7.117l11.17-.45s-.09,5.5,1.441,7.206a7.628,7.628,0,0,0,2.883,2.162,7.661,7.661,0,0,1-6.756,5.675c-5.675.631-11.712-.541-12.162-5.135",
    transform: "translate(-90.968 -16.435)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10291",
    "data-name": "Path 10291",
    d: "M259.576,60.536c-3.314,0-6.042-.719-7.709-2.069a4.912,4.912,0,0,1-1.87-3.44l-.017-.171.158-.067a6.16,6.16,0,0,0,2.328-2.254c1.117-1.719.955-6.928.953-6.981l-.008-.233,11.653-.47,0,.248c0,.055-.071,5.423,1.382,7.047a7.466,7.466,0,0,0,2.782,2.1l.2.066-.044.206a7.958,7.958,0,0,1-6.961,5.859,25.773,25.773,0,0,1-2.843.164m-9.092-5.4a4.451,4.451,0,0,0,1.68,2.961c2,1.618,5.81,2.292,10.2,1.8a7.46,7.46,0,0,0,6.5-5.3,8.472,8.472,0,0,1-2.777-2.146c-1.4-1.567-1.5-6-1.5-7.119l-10.693.431c.02,1.066.034,5.375-1.035,7.019a6.915,6.915,0,0,1-2.377,2.351",
    transform: "translate(-90.825 -16.295)",
    fill: "#333533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10292",
    "data-name": "Path 10292",
    d: "M228.813,123.632l40.9-6.412S268.15,107,268.323,101.1s5.545-17.5,5.545-17.5l19.986-2.022,2.368-16s-32.406-6.758-40.2-6.585c0,0-7.972,9.7-18.2.52,0,0-14.037,5.025-17.676,8.838a46.224,46.224,0,0,0-5.372,6.585s13.69,21.315,14.037,48.7",
    transform: "translate(-78.034 -21.433)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10293",
    "data-name": "Path 10293",
    d: "M228.444,123.765l0-.257c-.342-27-13.865-48.365-14-48.577l-.076-.118.074-.12a47.036,47.036,0,0,1,5.4-6.621c3.634-3.807,17.187-8.688,17.762-8.894l.125-.045.1.088c3.127,2.808,6.351,4.111,9.58,3.866a13.228,13.228,0,0,0,8.3-4.361l.065-.079.1,0c7.724-.168,39.93,6.521,40.254,6.59l.205.043L293.9,81.657l-20.032,2.026c-.556,1.224-5.311,11.833-5.472,17.3-.171,5.8,1.368,15.974,1.384,16.076l.033.219-.218.034ZM214.89,74.813c1.1,1.774,13.583,22.486,13.992,48.434l40.427-6.338c-.224-1.52-1.515-10.569-1.357-15.937.173-5.87,5.346-17.114,5.566-17.589l.053-.115,19.941-2.017,2.312-15.622c-2.739-.567-31.806-6.541-39.646-6.541l-.2,0a13.645,13.645,0,0,1-8.532,4.443c-3.322.25-6.625-1.057-9.816-3.889-1.4.508-14.085,5.2-17.466,8.737a48.326,48.326,0,0,0-5.269,6.434",
    transform: "translate(-77.884 -21.307)",
    fill: "#333533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10294",
    "data-name": "Path 10294",
    d: "M263.229,4.69A10.822,10.822,0,0,0,248.4,12q-.105.4-.192.833c-1.3,6.411,4.275,18.211,5.389,19.791a10.142,10.142,0,0,0,6.5,3.531c2.155.174,4.925.557,7.434-3.159s4-17.19,1.3-22.671a11.509,11.509,0,0,0-5.608-5.633",
    transform: "translate(-90.11 -1.366)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10295",
    "data-name": "Path 10295",
    d: "M261.689,36.362c-.532,0-1.038-.043-1.506-.081l-.241-.02a10.373,10.373,0,0,1-6.683-3.632c-1.008-1.43-6.782-13.307-5.428-19.979.058-.285.124-.569.195-.846a11.226,11.226,0,0,1,6.015-7.334,10.827,10.827,0,0,1,9.146-.134,11.7,11.7,0,0,1,5.726,5.747c2.8,5.7,1.213,19.165-1.317,22.914-1.934,2.865-4.076,3.367-5.908,3.367m-2.92-32.49a10.419,10.419,0,0,0-4.517,1.034,10.744,10.744,0,0,0-5.756,7.018c-.069.268-.133.545-.189.821-1.259,6.2,4.126,17.87,5.349,19.6a9.974,9.974,0,0,0,6.325,3.429l.243.02c2.064.173,4.634.388,6.97-3.073,2.414-3.577,3.97-16.963,1.284-22.429a11.23,11.23,0,0,0-5.489-5.518,10.29,10.29,0,0,0-4.221-.9",
    transform: "translate(-89.97 -1.231)",
    fill: "#333533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10296",
    "data-name": "Path 10296",
    d: "M248.1,23.328a7.032,7.032,0,0,1,2.042,2.7c.36,1.321.421,1.621.421,1.621a3.021,3.021,0,0,0,2.342-2.4c.541-2.163.6-4.685,2.282-5.766a10.858,10.858,0,0,0,1.862-1.321s-9.008,1.081-9.369,2.042.42,3.123.42,3.123",
    transform: "translate(-89.954 -6.599)",
    fill: "#333533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10297",
    "data-name": "Path 10297",
    d: "M273.768,16.68s1.081.3,3.063,2.522a12.758,12.758,0,0,1,2.522,5.705,39.21,39.21,0,0,0,.06-9.069s-4.384-.541-5.645.841",
    transform: "translate(-99.468 -5.717)",
    fill: "#333533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10298",
    "data-name": "Path 10298",
    d: "M411.807,51.508a16.612,16.612,0,0,1,3.2-.886c1.56-.231,3.235.289,4.506-.116s1.387.693,1.387.693-5.3,3.5-9.089.308",
    transform: "translate(-149.621 -18.318)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10299",
    "data-name": "Path 10299",
    d: "M415.339,52.941a5.926,5.926,0,0,1-3.924-1.388l-.288-.243.35-.14a16.673,16.673,0,0,1,3.247-.9,10.254,10.254,0,0,1,2.191-.01,6.4,6.4,0,0,0,2.279-.1,1.363,1.363,0,0,1,1.192.07,1.191,1.191,0,0,1,.488.816l.015.136-.115.076a11.257,11.257,0,0,1-5.434,1.68m-3.322-1.49c3.267,2.38,7.57,0,8.375-.486a.665.665,0,0,0-.257-.355.946.946,0,0,0-.8-.015,6.706,6.706,0,0,1-2.446.118,9.884,9.884,0,0,0-2.095.006,15.662,15.662,0,0,0-2.773.733",
    transform: "translate(-149.374 -18.189)",
    fill: "#333533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10300",
    "data-name": "Path 10300",
    d: "M400.128,50.2c-.116-.751-1.213-.058-1.213-.058l-2.242.942c1.349-.894,2.537-1.855,2.473-2.27-.116-.751-1.214-.058-1.214-.058l-2.888,1.213-2.645.893a27.15,27.15,0,0,1-3.286.628c-3.081.385-4.2-.809-4.89-.693a32.178,32.178,0,0,0-3.736,1.618l-3.812,1.771s-.148-.016-.19.063c-1.9.629-17.635,5.784-25.226,6.869-8.087,1.155-11.033.635-11.033.635s-7.914,16.809-2.368,16,40.666-17.329,40.666-17.329,10.527-1.369,12.253-1.714,6.132-2.11,6.174-2.869-1.136-.376-1.136-.376l-.886.154c.046-.08-.008.04.039-.043,1.775-.793,3.69-1.858,3.679-2.367-.017-.76-1.2-.215-1.2-.215l-1.14.313c1.776-1.042,3.9-2.558,3.817-3.109",
    transform: "translate(-122.037 -17.61)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10301",
    "data-name": "Path 10301",
    d: "M337.364,77.883a1.579,1.579,0,0,1-1.347-.632c-2.128-2.872,3.634-15.2,3.88-15.72l.074-.156.17.03c.03.005,3.024.5,10.962-.637,7.51-1.073,23.086-6.166,25.128-6.84a.426.426,0,0,1,.274-.1l3.763-1.748a29.99,29.99,0,0,1,3.794-1.636,2.017,2.017,0,0,1,1,.222,7.27,7.27,0,0,0,3.9.471,26.827,26.827,0,0,0,3.258-.623l2.628-.888,2.856-1.2c.159-.1.782-.452,1.206-.26a.593.593,0,0,1,.336.485c.02.131.07.46-.993,1.343l.433-.181c.16-.1.782-.452,1.206-.26a.592.592,0,0,1,.336.485c.091.594-1.338,1.676-2.523,2.462a1.049,1.049,0,0,1,.774.054.592.592,0,0,1,.27.524c.012.544-1.23,1.311-2.461,1.936a.888.888,0,0,1,.536.155.619.619,0,0,1,.229.557c-.058,1.052-5.048,2.817-6.355,3.078-1.681.336-11.454,1.611-12.233,1.712-1.839.865-35.218,16.534-40.7,17.333a2.815,2.815,0,0,1-.4.031m2.873-16.007c-.661,1.436-5.706,12.609-3.856,15.106a1.271,1.271,0,0,0,1.32.423c5.449-.8,40.252-17.145,40.6-17.31l.067-.019c.106-.014,10.539-1.373,12.238-1.711,1.991-.4,5.911-2.138,5.992-2.661.007-.125-.037-.159-.053-.172a1.161,1.161,0,0,0-.788.026l-.031.008-1.361.237.241-.419a.361.361,0,0,1,.062-.081l.023-.019.024-.015.032-.022c2.383-1.063,3.524-1.915,3.545-2.156,0-.115-.042-.139-.057-.148-.144-.09-.568.02-.817.136l-.035.013-2.791.765,1.476-.867c2.2-1.291,3.72-2.554,3.707-2.88-.018-.113-.059-.132-.075-.14-.157-.072-.561.094-.794.241l-.033.017-2.241.942-.213-.4c1.964-1.3,2.379-1.92,2.374-2.049-.018-.113-.06-.132-.075-.139-.157-.073-.561.094-.794.241l-.033.017-2.889,1.213-2.66.9a27.284,27.284,0,0,1-3.33.639,7.694,7.694,0,0,1-4.118-.5,1.864,1.864,0,0,0-.764-.2,29.862,29.862,0,0,0-3.672,1.6l-3.874,1.8-.059-.007-.012.024-.087.029c-1.783.589-17.639,5.788-25.264,6.877-7.054,1.008-10.19.751-10.93.66",
    transform: "translate(-121.914 -17.481)",
    fill: "#333533"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10302",
    "data-name": "Path 10302",
    d: "M419.531,60.791l-.055-.449a41.848,41.848,0,0,0,5.882-1.105l.152.426a41.29,41.29,0,0,1-5.979,1.128",
    transform: "translate(-152.407 -21.522)",
    fill: "#333533"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17368",
    "data-name": "Rectangle 17368",
    width: 26.139,
    height: 2.352,
    transform: "translate(155.169 13.051) rotate(-10.464)",
    fill: "#fd734e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10303",
    "data-name": "Path 10303",
    d: "M248.532,27.106a1.618,1.618,0,0,0-2.168.991c-.558,1.61,1.548,4.212,3.469,4.832s-1.3-5.823-1.3-5.823",
    transform: "translate(-89.478 -9.806)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10304",
    "data-name": "Path 10304",
    d: "M249.619,33.022a6.272,6.272,0,0,1-3.332-3.01A2.782,2.782,0,0,1,246,27.88a1.806,1.806,0,0,1,.929-1.11,2.187,2.187,0,0,1,1.556-.029l-.173.453a1.713,1.713,0,0,0-1.181.017,1.336,1.336,0,0,0-.671.827,2.391,2.391,0,0,0,.267,1.757,5.831,5.831,0,0,0,3.046,2.764Z",
    transform: "translate(-89.339 -9.668)",
    fill: "#333533"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10305",
    "data-name": "Path 10305",
    d: "M266.55,30.523c0,.575-.3,1.041-.661,1.041s-.66-.466-.66-1.041.3-1.041.66-1.041.661.466.661,1.041",
    transform: "translate(-96.365 -10.712)",
    fill: "#333533"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10306",
    "data-name": "Path 10306",
    d: "M278.348,30.083c0,.575-.3,1.041-.661,1.041s-.661-.466-.661-1.041.3-1.041.661-1.041.661.466.661,1.041",
    transform: "translate(-100.651 -10.552)",
    fill: "#333533"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10307",
    "data-name": "Path 10307",
    d: "M261.085,27.379l-.409-.232c.038-.067.963-1.643,4.336-.957l-.094.461c-3.007-.612-3.824.714-3.833.728",
    transform: "translate(-94.711 -9.453)",
    fill: "#333533"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10308",
    "data-name": "Path 10308",
    d: "M278.216,26.812a2.641,2.641,0,0,0-3.257-.353l-.278-.379a3.14,3.14,0,0,1,3.831.367Z",
    transform: "translate(-99.799 -9.3)",
    fill: "#333533"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10309",
    "data-name": "Path 10309",
    d: "M236.823,136.191s2.773-19.755,1.386-32.059l35.352-4.852,4.852,33.1-41.59,5.892Z",
    transform: "translate(-86.044 -36.071)",
    fill: "#ffd447"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10310",
    "data-name": "Path 10310",
    d: "M235.045,92.265a150.559,150.559,0,0,0-6.931-23.741l3.639-1.906s3.813,6.412,8.318,25.474Z",
    transform: "translate(-82.88 -24.204)",
    fill: "#ffd447"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10311",
    "data-name": "Path 10311",
    d: "M282.55,59s3.293,24.607,3.466,27.034l4.159-1.387-3.119-25.3Z",
    transform: "translate(-102.658 -21.435)",
    fill: "#ffd447"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10312",
    "data-name": "Path 10312",
    d: "M245.84,14.6a11.223,11.223,0,0,1,3.243-10.54c4.865-4.685,17.386-5.4,20.81,5.675Z",
    transform: "translate(-89.226 -0.303)",
    fill: "#fd734e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17369",
    "data-name": "Rectangle 17369",
    width: 23.992,
    height: 0.471,
    transform: "translate(156.484 11.93) rotate(-9.5)",
    fill: "#333533"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10313",
    "data-name": "Path 10313",
    d: "M212.727,377.716l2.07,13.079-1.049,14.211H239.5l-.2-3.106a7.881,7.881,0,0,0-3.693-6.186l-7.2-4.493L226.626,378.8Z",
    transform: "translate(-77.29 -137.235)",
    fill: "#333533"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10314",
    "data-name": "Path 10314",
    d: "M316.268,374.683l2.411,14.268-1.049,14.211h25.756l-.2-3.106a7.881,7.881,0,0,0-3.693-6.186l-7.2-4.494-1.1-16.734Z",
    transform: "translate(-114.909 -135.392)",
    fill: "#333533"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10315",
    "data-name": "Path 10315",
    d: "M190.183,210.784l4.4,36.495,4.036,55.439,6.2,3.886,13.616-.681,4.141-4.879-3.63-76.02-1.816-47.881-24.394.893Z",
    transform: "translate(-69.099 -64.361)",
    fill: "#6a7fdb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M204.634,306.7l-6.352-3.982-.008-.112-4.036-55.439-4.405-36.506,0-.022,2.568-32.947,24.813-.908,1.824,48.1,3.635,76.105-4.26,5.019Zm-5.926-4.239,6.043,3.789,13.45-.672,4.022-4.739L218.6,224.9l-1.808-47.661-23.975.877-2.536,32.53,4.4,36.472Z",
    transform: "translate(-68.972 -64.229)",
    fill: "#333533"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M102.026,232.247l.341,75.225,3.744,6.127h17.36l4.085-6.127,3.4-73.183.681-46.633-30.294,1.7Z",
    transform: "translate(-36.822 -68.181)",
    fill: "#087e8b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M59.453,193.393,57.41,251.94l-5.787,56.845,3.4,5.787h17.36l3.744-6.127,10.892-65.694,6.467-52.42Z",
    transform: "translate(-18.756 -69.152)",
    fill: "#087e8b"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M90.3,65.183a9.2,9.2,0,0,0,5.049-2.1c2.553-2.042,3.064-8.594,3.064-8.594l10.807.17a11.242,11.242,0,0,0,6.949,9.843s.795,1.3.2,4.113-3.234,7.4-9.02,6.978S90.863,71.026,90.3,65.183",
    transform: "translate(-32.807 -19.797)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M107.938,75.713q-.366,0-.751-.028c-5.545-.407-16.661-4.522-17.253-10.61l-.023-.237.239-.006a9.082,9.082,0,0,0,4.915-2.05c2.449-1.96,2.976-8.374,2.981-8.439l.016-.208,11.237.177,0,.22a11.11,11.11,0,0,0,6.817,9.638l.064.029.036.059c.034.057.833,1.413.226,4.275-.542,2.555-3.006,7.182-8.5,7.182M90.4,65.259c.821,5.722,11.467,9.59,16.815,9.983,5.709.421,8.209-4.079,8.787-6.8a6.216,6.216,0,0,0-.142-3.9,11.569,11.569,0,0,1-7-9.8l-10.39-.163c-.112,1.16-.759,6.647-3.128,8.543A9.663,9.663,0,0,1,90.4,65.259",
    transform: "translate(-32.668 -19.668)",
    fill: "#333533"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M88.15,31.8a19.8,19.8,0,0,0,.186,4.743,3.125,3.125,0,0,0,2.185,1.953s-.651.372.046,1.07,2.612,3.161,2.612,3.161,2.361,1.821,3.291,1.588-5.205-14.792-5.205-14.792Z",
    transform: "translate(-32.004 -10.724)",
    fill: "#333533"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M96.983,8.657a12.481,12.481,0,0,0-6.172,10.566c-.314,7.636,6.765,18.1,7.881,19.876s5.973,2.885,8.23,3.348a8.761,8.761,0,0,0,4.889-.408s2.434-1.684,4.317-11.832-.209-28.071-19.144-21.55",
    transform: "translate(-32.991 -2.639)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M108.529,42.718a8.839,8.839,0,0,1-1.783-.18c-4.732-.97-7.55-2.131-8.377-3.449-.073-.116-.171-.269-.29-.455-5.256-8.19-7.822-14.768-7.625-19.553a12.818,12.818,0,0,1,6.3-10.76l.027-.012c6.433-2.215,11.46-1.817,14.942,1.184,4.96,4.274,5.834,13.438,4.5,20.624-1.879,10.123-4.309,11.906-4.412,11.977l-.037.021a8.608,8.608,0,0,1-3.244.6M96.943,8.735A12.365,12.365,0,0,0,90.908,19.1c-.192,4.688,2.349,11.177,7.553,19.287.12.188.22.342.293.459.521.831,2.347,2.069,8.082,3.245a8.612,8.612,0,0,0,4.728-.383c.2-.162,2.451-2.207,4.208-11.675,1.31-7.058.472-16.04-4.35-20.2-3.348-2.885-8.22-3.255-14.48-1.1",
    transform: "translate(-32.86 -2.507)",
    fill: "#333533"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M117.651,21.775s.113,1.645,2.666,1.815,3.064.057,4.312,1.362a10.181,10.181,0,0,1,1.872,2.836,3.384,3.384,0,0,0,1.361-2.95,8.614,8.614,0,0,0-1.248-4.255s-8.453.17-8.964,1.191",
    transform: "translate(-42.746 -7.479)",
    fill: "#333533"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M92.013,34.168s-1.07-4.464.884-4.882,2.627.3,3.254,1.488a23.116,23.116,0,0,1,1.238,3.155l1.878.565s-.755-6.021.221-7.486,6.556-2.311,7.6-4.822-.849-1.779-.849-1.779-15.761,6-16.528,6.625-.977.628-.977.628Z",
    transform: "translate(-32.24 -7.378)",
    fill: "#333533"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M86.643,28.334,84.65,25.973c.4-.339,10.052-8.3,30.837-9.359l.157,3.085c-19.755,1.008-28.911,8.558-29,8.635",
    transform: "translate(-30.756 -6.036)",
    fill: "#fd734e"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M86.649,20.609S82.96,14.68,90,7.5c6.765-6.9,21.341-5.789,24.27,5.649a68.07,68.07,0,0,0-27.618,7.462",
    transform: "translate(-31.131 -1.166)",
    fill: "#fd734e"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M96.049,40.18c-1.946-1.616-2.848-3.087-2.68-4.37A2.644,2.644,0,0,1,94.816,33.9l.259.561-.13-.28.131.279A2.054,2.054,0,0,0,93.982,35.9c-.132,1.043.719,2.36,2.463,3.807Z",
    transform: "translate(-33.917 -12.315)",
    fill: "#333533"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M97.586,39.154a5.273,5.273,0,0,1-1.9-2.436l.581-.211a4.718,4.718,0,0,0,1.639,2.121Z",
    transform: "translate(-34.767 -13.264)",
    fill: "#333533"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M116.321,37.844c0,.629-.312,1.139-.7,1.139s-.7-.51-.7-1.139.313-1.139.7-1.139.7.51.7,1.139",
    transform: "translate(-41.756 -13.336)",
    fill: "#333533"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10331",
    "data-name": "Path 10331",
    d: "M128.594,37.042c0,.629-.26,1.139-.581,1.139s-.581-.51-.581-1.139.26-1.139.581-1.139.581.51.581,1.139",
    transform: "translate(-46.299 -13.045)",
    fill: "#333533"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10332",
    "data-name": "Path 10332",
    d: "M111.539,34.788l-.525-.327a3.688,3.688,0,0,1,5.1-1.088l-.3.539a3.044,3.044,0,0,0-4.277.876",
    transform: "translate(-40.335 -11.905)",
    fill: "#333533"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10333",
    "data-name": "Path 10333",
    d: "M128.493,34.307a2.24,2.24,0,0,0-3.075-.5l-.331-.521a2.8,2.8,0,0,1,3.912.667Z",
    transform: "translate(-45.448 -11.908)",
    fill: "#333533"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10334",
    "data-name": "Path 10334",
    d: "M86.729,24.974l-.353-.507c.124-.087,12.6-8.633,27.946-8.006l-.025.618c-15.125-.612-27.446,7.81-27.569,7.9",
    transform: "translate(-31.383 -5.969)",
    fill: "#333533"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10335",
    "data-name": "Path 10335",
    d: "M111.68,13.027C108.191,3.971,97.96,6.013,97.525,6.1L97.4,5.5c.111-.024,11.18-2.246,14.859,7.3Z",
    transform: "translate(-35.387 -1.911)",
    fill: "#333533"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10336",
    "data-name": "Path 10336",
    d: "M105.087,59.434A13.481,13.481,0,0,0,117,63.121l-1.021-1.758s-7.091.113-10.892-1.929",
    transform: "translate(-38.181 -21.594)",
    fill: "#333533"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10337",
    "data-name": "Path 10337",
    d: "M96.448,68.906a.191.191,0,0,1,.358-.062c1.14,2.134,5.74,10.038,11.189,9.744s8.7-6.946,9.468-8.708a.191.191,0,0,1,.353.006,112.473,112.473,0,0,1,6.4,25.212c1.961,14.381,2.248,48.845,2.268,51.567a.191.191,0,0,1-.17.191c-2.233.251-25.678,2.822-29.783.661-4.284-2.255-.951-72.176-.909-73.061l0-.018Z",
    transform: "translate(-34.28 -24.976)",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10338",
    "data-name": "Path 10338",
    d: "M103.975,148.465c-3.542,0-6.442-.233-7.671-.879-.681-.359-1.637-2.037-2.074-12.43-.257-6.1-.3-14.452-.122-24.815.3-17.774,1.134-35.287,1.169-36.024l0-.04.819-5.53.22.032-.22-.032a.413.413,0,0,1,.774-.134c1.245,2.33,5.715,9.9,10.981,9.626s8.434-6.635,9.276-8.575a.413.413,0,0,1,.763.011,113.415,113.415,0,0,1,6.418,25.264c1.946,14.27,2.243,47.818,2.27,51.6a.413.413,0,0,1-.367.413c-1.847.208-13.845,1.517-22.242,1.517M96.527,68.9l-.805,5.438c-.035.733-.867,18.239-1.168,36.006-.524,30.884,1,36.341,1.958,36.844,3.265,1.718,20.146.381,29.628-.682-.029-3.914-.329-37.3-2.266-51.511a113.163,113.163,0,0,0-6.364-25.09c-.911,2.076-4.161,8.478-9.63,8.773s-10.017-7.3-11.352-9.779",
    transform: "translate(-34.154 -24.849)",
    fill: "#333533"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10339",
    "data-name": "Path 10339",
    d: "M82.406,158.393l-33.813.227s11.348-34.947,16.34-57.639S68.79,71.708,68.79,71.708l11.12-3.633s2.576,7.185,4.059,25.019q.2,2.4.372,5.067c.255,4.032.452,8.516.56,13.486.683,31.541-2.5,46.746-2.5,46.746",
    transform: "translate(-17.655 -24.734)",
    fill: "#333533"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10340",
    "data-name": "Path 10340",
    d: "M97.692,112.438l-12.355,2.649,1.132-5.808,10.851-1.908q.2,2.4.372,5.067",
    transform: "translate(-31.005 -39.011)",
    fill: "#fd734e"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10341",
    "data-name": "Path 10341",
    d: "M155.21,154.5l-20.652,1.134-2.445-57.825L131.9,92.9l-.976-23.036,8.849,2.948,3.971,21.029.818,4.323Z",
    transform: "translate(-47.57 -25.383)",
    fill: "#333533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8180",
    "data-name": "Group 8180",
    transform: "translate(4.638 82.338)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8179",
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8178",
    "data-name": "Group 8178",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10342",
    "data-name": "Path 10342",
    d: "M9.576,138.117c-.434,2.006-1.15,2.093-1.6.194a19.035,19.035,0,0,1-.027-7.072c.434-2.006,1.15-2.093,1.6-.194a19.035,19.035,0,0,1,.027,7.072",
    transform: "translate(-7.411 -129.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10343",
    "data-name": "Path 10343",
    d: "M8.625,139.775c-.421,0-.745-.5-.99-1.54a19.318,19.318,0,0,1-.028-7.171c.249-1.149.6-1.734,1.038-1.738s.75.5,1,1.54a19.332,19.332,0,0,1,.028,7.171c-.249,1.15-.6,1.734-1.038,1.738Zm.025-10.005c-.08,0-.364.257-.609,1.389a18.8,18.8,0,0,0,.026,6.974c.232.979.486,1.2.558,1.2s.364-.257.608-1.389a18.791,18.791,0,0,0-.025-6.973c-.232-.979-.486-1.2-.558-1.2",
    transform: "translate(-7.285 -129.325)",
    fill: "#333533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10344",
    "data-name": "Path 10344",
    d: "M53.23,139.792l3.108.008,1.254,0,4.475.011,1.007,0,3.286.008,1.01,0,1.147,0,2.614.006,1.292,0,2.586.007,1.72,0,1.417,0c.3,0,.6-.523.826-1.564a19,19,0,0,0-.027-7.072c-.217-.915-.495-1.369-.774-1.37l-1.393,0-1.822-.005-2.371-.006-2.484-.006-22.054-.056H48l-2.2-.005h-.1l-11.172-.028h-.265l-4.314-.011h-.079l-5.27-.013h-.468L20.3,129.7h-.5l-1.62,0-1.334,0-2.485-.006-2.371-.006-1.822,0-1.394,0c-.3,0-.6.523-.826,1.564a19.008,19.008,0,0,0,.027,7.072c.216.915.495,1.369.774,1.369l1.636,0,1.091,0,7.218.018h.527l1.619,0,2.981.008,1.125,0,1.7,0,1.377,0,1.285,0,1.64,0,2.722.007,1.42,0,2.1.005,6.258.016,6.257.016,2.1.005,1.42,0",
    transform: "translate(-7.411 -129.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10345",
    "data-name": "Path 10345",
    d: "M78.019,139.951l-69.4-.176c-.421,0-.744-.506-.989-1.541a19.315,19.315,0,0,1-.027-7.17c.25-1.154.6-1.739,1.042-1.739l25.75.065,43.646.111c.421,0,.744.5.989,1.541a19.315,19.315,0,0,1,.028,7.17c-.25,1.154-.6,1.739-1.043,1.739M53.1,139.444l24.916.063c.08,0,.363-.255.609-1.389a18.791,18.791,0,0,0-.026-6.973c-.231-.978-.487-1.2-.558-1.2L8.649,129.77c-.08,0-.364.255-.609,1.389a18.778,18.778,0,0,0,.026,6.973c.231.978.486,1.2.558,1.2Z",
    transform: "translate(-7.285 -129.325)",
    fill: "#333533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10346",
    "data-name": "Path 10346",
    d: "M118.572,138.393c-.434,2.006-1.15,2.093-1.6.194a19.035,19.035,0,0,1-.027-7.072c.434-2.006,1.15-2.093,1.6-.194a19.035,19.035,0,0,1,.027,7.072",
    transform: "translate(-47.012 -129.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10347",
    "data-name": "Path 10347",
    d: "M117.619,140.052c-.421,0-.745-.5-.99-1.541a19.315,19.315,0,0,1-.028-7.17c.249-1.149.6-1.734,1.038-1.739s.75.5,1,1.541a19.329,19.329,0,0,1,.028,7.17c-.249,1.15-.6,1.734-1.038,1.739Zm.025-10.005c-.08,0-.364.258-.609,1.389a18.791,18.791,0,0,0,.026,6.973c.232.979.486,1.2.558,1.2s.364-.257.608-1.389a18.791,18.791,0,0,0-.025-6.973c-.232-.979-.486-1.2-.558-1.2",
    transform: "translate(-46.886 -129.426)",
    fill: "#333533"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8183",
    "data-name": "Group 8183",
    transform: "translate(7.289 81.318)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8182",
    "data-name": "Group 8182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8181",
    "data-name": "Group 8181",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10348",
    "data-name": "Path 10348",
    d: "M15.208,164.735c.115,2.049-.553,2.324-1.49.612a19.024,19.024,0,0,1-1.907-6.81c-.115-2.049.553-2.324,1.491-.612a19.036,19.036,0,0,1,1.907,6.81",
    transform: "translate(-11.575 -138.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10349",
    "data-name": "Path 10349",
    d: "M14.625,166.567c-.37,0-.774-.408-1.23-1.24a19.321,19.321,0,0,1-1.934-6.9c-.066-1.175.115-1.831.539-1.952s.855.283,1.369,1.221a19.311,19.311,0,0,1,1.934,6.9c.066,1.175-.115,1.831-.538,1.953a.523.523,0,0,1-.139.019m-2.49-9.671c-.09.024-.295.346-.23,1.5a18.8,18.8,0,0,0,1.88,6.716c.485.883.788,1.026.858,1.007s.281-.345.216-1.5a18.786,18.786,0,0,0-1.88-6.716c-.458-.835-.754-1.008-.844-1.008",
    transform: "translate(-11.448 -138.161)",
    fill: "#333533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10350",
    "data-name": "Path 10350",
    d: "M57.733,144.3l3-.819,1.21-.331,4.317-1.179.971-.265,3.17-.866.975-.267,1.106-.3L75,139.584l1.246-.341,2.5-.682,1.659-.453,1.366-.373c.29-.079.44-.665.381-1.727a19.036,19.036,0,0,0-1.907-6.81c-.452-.824-.841-1.188-1.11-1.114l-1.345.367-1.757.481-2.287.625-2.4.655-21.274,5.812-.04.011-2.127.581-.1.027-10.777,2.945-.256.07-4.161,1.136-.076.021L27.45,142.2l-.451.123-3.694,1.009-.48.131-1.562.427-1.287.351-2.4.655-2.288.625-1.757.481-1.344.367c-.29.08-.441.665-.381,1.727a19.01,19.01,0,0,0,1.907,6.81c.452.824.841,1.188,1.11,1.115l1.578-.431,1.053-.288,6.963-1.9.507-.139,1.562-.427,2.876-.786,1.086-.3,1.636-.447,1.328-.363,1.239-.339,1.582-.432,2.626-.717,1.37-.374,2.03-.555,6.036-1.65,6.036-1.649,2.03-.555,1.37-.374",
    transform: "translate(-11.575 -127.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M14.625,156.129c-.369,0-.773-.408-1.229-1.24a19.324,19.324,0,0,1-1.934-6.9c-.066-1.18.117-1.837.544-1.953l66.941-18.29c.4-.113.853.288,1.363,1.222a19.3,19.3,0,0,1,1.935,6.9c.066,1.18-.117,1.837-.544,1.953l-66.942,18.29a.5.5,0,0,1-.134.018m64.452-27.961c-.013,0-66.954,18.291-66.954,18.291-.077.021-.283.342-.217,1.5a18.811,18.811,0,0,0,1.879,6.716c.483.88.787,1.028.858,1.007L57.549,143.96l.059.214-.059-.214,24.034-6.567c.078-.021.282-.342.218-1.5a18.767,18.767,0,0,0-1.881-6.716c-.457-.835-.754-1.009-.843-1.009",
    transform: "translate(-11.448 -127.723)",
    fill: "#333533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M120.35,136.008c.115,2.049-.553,2.324-1.49.612a19.024,19.024,0,0,1-1.907-6.81c-.115-2.049.553-2.324,1.491-.612a19.036,19.036,0,0,1,1.907,6.81",
    transform: "translate(-49.776 -127.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M119.768,137.84c-.37,0-.774-.408-1.231-1.24a19.326,19.326,0,0,1-1.933-6.9c-.067-1.174.115-1.831.538-1.952s.854.283,1.368,1.221a19.3,19.3,0,0,1,1.935,6.9c.066,1.174-.115,1.831-.539,1.952a.488.488,0,0,1-.139.02m-2.49-9.671c-.09.024-.295.346-.23,1.5a18.8,18.8,0,0,0,1.88,6.716c.484.883.786,1.028.858,1.007s.281-.344.216-1.5a18.766,18.766,0,0,0-1.881-6.716c-.457-.835-.754-1.008-.843-1.008",
    transform: "translate(-49.649 -127.723)",
    fill: "#333533"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8186",
    "data-name": "Group 8186",
    transform: "translate(0 80.431)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8185",
    "data-name": "Group 8185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8184",
    "data-name": "Group 8184",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M3.04,151.533c-.118,2.049-.813,2.246-1.55.439A19,19,0,0,1,.366,144.99c.118-2.049.812-2.246,1.55-.439a19.05,19.05,0,0,1,1.124,6.982",
    transform: "translate(-0.127 -132.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M2.3,153.3c-.388,0-.761-.451-1.138-1.375a19.33,19.33,0,0,1-1.14-7.079c.067-1.175.322-1.806.756-1.879.418-.071.817.378,1.222,1.368a19.324,19.324,0,0,1,1.14,7.079c-.067,1.175-.322,1.806-.756,1.879a.546.546,0,0,1-.084.007M.853,143.41c-.086.013-.326.311-.392,1.466a18.788,18.788,0,0,0,1.107,6.886c.382.934.665,1.107.738,1.1s.319-.311.385-1.466a18.79,18.79,0,0,0-1.107-6.886c-.37-.9-.651-1.1-.731-1.1",
    transform: "translate(0 -132.374)",
    fill: "#333533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M46.424,140.373,49.5,139.9l1.239-.192,4.424-.683,1-.153,3.247-.5,1-.155,1.133-.175,2.584-.4,1.277-.2,2.556-.395,1.7-.262,1.4-.216c.3-.046.513-.61.574-1.673a19.023,19.023,0,0,0-1.123-6.982c-.356-.87-.7-1.275-.977-1.233l-1.377.213-1.8.278L64,127.535l-2.456.379-21.8,3.366-.041.006-2.179.336-.1.016-11.041,1.705-.262.041-4.263.658-.078.012-5.208.8-.463.072-3.784.584-.492.076-1.6.247-1.319.2-2.455.379-2.344.362-1.8.278-1.378.213c-.3.046-.513.61-.574,1.673a19.024,19.024,0,0,0,1.124,6.982c.356.87.7,1.275.977,1.233l1.617-.25,1.079-.166,7.134-1.1.52-.08,1.6-.247,2.946-.455,1.112-.172,1.676-.259,1.361-.21,1.27-.2,1.621-.25,2.689-.415,1.4-.217,2.079-.321,6.185-.955,6.184-.955,2.08-.322,1.4-.216",
    transform: "translate(-0.126 -126.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10357",
    "data-name": "Path 10357",
    d: "M2.3,147.261c-.388,0-.761-.451-1.138-1.375a19.3,19.3,0,0,1-1.14-7.079c.067-1.18.324-1.812.761-1.879L69.36,126.337c.414-.063.814.383,1.217,1.369a19.325,19.325,0,0,1,1.14,7.079c-.068,1.179-.324,1.812-.761,1.879L2.373,147.255a.541.541,0,0,1-.078.006m67.14-20.486L.847,137.367c-.079.012-.32.308-.386,1.466a18.788,18.788,0,0,0,1.107,6.886c.38.931.667,1.11.737,1.1l68.582-10.591c.079-.013.319-.308.386-1.466a18.8,18.8,0,0,0-1.107-6.886c-.37-.9-.651-1.1-.731-1.1",
    transform: "translate(0 -126.33)",
    fill: "#333533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M110.759,134.9c-.118,2.049-.812,2.246-1.55.439a19.018,19.018,0,0,1-1.124-6.982c.118-2.05.812-2.247,1.55-.44a19.024,19.024,0,0,1,1.124,6.982",
    transform: "translate(-39.264 -126.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M110.014,136.67c-.388,0-.761-.451-1.138-1.375a19.33,19.33,0,0,1-1.14-7.079c.067-1.174.322-1.806.756-1.879.416-.069.817.378,1.222,1.368a19.326,19.326,0,0,1,1.14,7.079c-.067,1.174-.322,1.806-.756,1.878a.537.537,0,0,1-.084.007m-1.442-9.895c-.086.013-.325.311-.392,1.466a18.8,18.8,0,0,0,1.107,6.886c.381.932.668,1.108.738,1.1s.319-.311.385-1.466a18.791,18.791,0,0,0-1.107-6.886c-.37-.9-.651-1.1-.731-1.1",
    transform: "translate(-39.137 -126.33)",
    fill: "#333533"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M45.228,134.1s-3.6,11.745,1.587,19.469c4.645,6.921,54.123-1.939,54.123-1.939l.17-7.319S89.659,141.93,80.517,140.5c-5.856-.918-10.8-.86-11.065-1.459a4.309,4.309,0,0,1-.34-2.723S46.873,130.7,45.228,134.1",
    transform: "translate(-15.991 -48.325)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10361",
    "data-name": "Path 10361",
    d: "M59.268,156.313c-6.428,0-11.4-.723-12.754-2.743-5.183-7.722-1.652-19.539-1.616-19.657l.013-.032c1.675-3.468,21.844,1.514,24.138,2.093l.222.057-.063.22a4.154,4.154,0,0,0,.33,2.572,15.571,15.571,0,0,0,3.771.523c1.976.171,4.436.384,7.126.805,9.042,1.418,20.487,3.8,20.6,3.82l.181.038-.179,7.685-.179.032c-1.438.257-25.867,4.587-41.592,4.587M45.318,134.059c-.15.507-3.411,11.85,1.564,19.263,4.373,6.516,50.451-1.429,53.72-2l.162-6.951c-1.5-.309-11.991-2.459-20.4-3.778-2.675-.42-5.126-.632-7.1-.8-2.929-.253-3.951-.363-4.139-.786a4.743,4.743,0,0,1-.4-2.649c-6.273-1.57-22.092-4.9-23.416-2.295",
    transform: "translate(-15.874 -48.2)",
    fill: "#333533"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M70.532,74.823c-1.567-1.338-3.668-1.063-5.412.036C60.8,77.576,55.7,81.66,50.251,95.049c-6.075,14.935-5.515,17.585-5.515,17.585l24.633,2.214s11.51-31.19,1.162-40.026",
    transform: "translate(-16.249 -26.858)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M69.393,114.956l-24.966-2.244-.034-.161c-.024-.111-.5-2.887,5.526-17.714,5.489-13.495,10.6-17.552,14.955-20.3,2.053-1.292,4.174-1.3,5.675-.017,4.356,3.719,5.491,11.637,3.374,23.534A111.323,111.323,0,0,1,69.451,114.8ZM44.817,112.3l24.276,2.183c.866-2.424,10.9-31.308,1.169-39.62-1.345-1.149-3.271-1.128-5.15.055C60.812,77.624,55.77,81.632,50.33,95c-5.23,12.857-5.528,16.537-5.514,17.3",
    transform: "translate(-16.123 -26.729)",
    fill: "#333533"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M55.9,385.471l1.191,5.787L54.03,406.235H85.345s2.042-5.447-12.765-13.105l.681-7.659Z",
    transform: "translate(-19.631 -140.052)",
    fill: "#333533"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M107.762,385.471l1.191,5.787-3.063,14.977h31.315s2.042-5.447-12.765-13.105l.681-7.659Z",
    transform: "translate(-38.473 -140.052)",
    fill: "#333533"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M102.778,261.939l-.437-.078,7.232-40.839.036-.045,3.573-4.414,3.6-23.73.439.067L113.6,216.75l-3.612,4.463Z",
    transform: "translate(-37.183 -70.062)",
    fill: "#333533"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M56.961,314.529l-.442-.046L61.9,263.5l3.682-47.291.442.035-3.682,47.3Z",
    transform: "translate(-20.535 -78.556)",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10368",
    "data-name": "Path 10368",
    d: "M110.341,331.942l-.444-.023,1.7-32,.566-39.641.444.006-.566,39.649Z",
    transform: "translate(-39.929 -94.565)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10369",
    "data-name": "Path 10369",
    d: "M146.638,111.348l-1.514-.041-12.454-.35-.208-4.914,11.844.94,1.483.117Z",
    transform: "translate(-48.127 -38.529)",
    fill: "#fd734e"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10370",
    "data-name": "Path 10370",
    d: "M61.986,187.9l-.017-.444c.116,0,11.64-.6,18.714-14.746l.4.2c-7.2,14.4-18.977,14.987-19.1,14.991",
    transform: "translate(-22.515 -62.751)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10371",
    "data-name": "Path 10371",
    d: "M116.264,230.253l-6.018,17.89,2.407-13.429Z",
    transform: "translate(-40.055 -83.657)",
    fill: "#333533"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10372",
    "data-name": "Path 10372",
    d: "M66.088,144.345l-.132-.424c.038-.012,3.876-1.187,11.766-1.426l.013.444c-7.819.236-11.61,1.394-11.647,1.406",
    transform: "translate(-23.964 -51.772)",
    fill: "#333533"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10373",
    "data-name": "Path 10373",
    d: "M44.856,137.346l24.427,1.133.135-1.538-23.884-2.212Z",
    transform: "translate(-16.297 -48.95)",
    fill: "#333533"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M173.7,61.975a9.2,9.2,0,0,0,5.049-2.1c2.553-2.042,3.064-8.594,3.064-8.594l10.808.17a11.242,11.242,0,0,0,6.949,9.843s.795,1.3.2,4.113-3.234,7.4-9.02,6.978-16.48-4.567-17.048-10.41",
    transform: "translate(-63.11 -18.632)",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10375",
    "data-name": "Path 10375",
    d: "M191.341,72.506q-.366,0-.751-.028c-5.545-.408-16.661-4.522-17.253-10.61l-.023-.237.239-.006a9.08,9.08,0,0,0,4.916-2.05c2.448-1.958,2.976-8.375,2.981-8.439l.017-.208L192.7,51.1l0,.221a11.108,11.108,0,0,0,6.817,9.637l.064.029.036.059c.034.057.833,1.413.226,4.275-.542,2.555-3.006,7.182-8.5,7.182M173.808,62.052c.822,5.722,11.467,9.59,16.815,9.982,5.708.416,8.209-4.079,8.787-6.8a6.219,6.219,0,0,0-.142-3.9,11.569,11.569,0,0,1-7-9.8l-10.39-.164c-.112,1.161-.759,6.649-3.128,8.543a9.661,9.661,0,0,1-4.939,2.131",
    transform: "translate(-62.97 -18.503)",
    fill: "#333533"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M171.553,28.587a19.8,19.8,0,0,0,.186,4.743,3.125,3.125,0,0,0,2.185,1.953s-.651.372.046,1.07a3.442,3.442,0,0,0,1.907.79s1.86,1.906,2.789,1.674-4-12.507-4-12.507Z",
    transform: "translate(-62.307 -9.559)",
    fill: "#333533"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M180.386,5.45a12.482,12.482,0,0,0-6.172,10.566c-.314,7.636,6.765,18.1,7.881,19.876s5.973,2.885,8.23,3.348a8.761,8.761,0,0,0,4.889-.408S197.648,37.147,199.53,27s-.209-28.07-19.144-21.549",
    transform: "translate(-63.293 -1.474)",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10378",
    "data-name": "Path 10378",
    d: "M191.932,39.51a8.849,8.849,0,0,1-1.784-.18c-4.73-.97-7.549-2.13-8.377-3.449-.073-.115-.171-.268-.29-.455-5.256-8.19-7.822-14.768-7.625-19.552a12.82,12.82,0,0,1,6.3-10.76l.027-.012c6.433-2.215,11.46-1.817,14.942,1.184,4.96,4.274,5.834,13.438,4.5,20.624-1.879,10.123-4.309,11.906-4.412,11.977l-.037.021a8.608,8.608,0,0,1-3.244.6M180.346,5.527a12.366,12.366,0,0,0-6.034,10.366c-.193,4.688,2.349,11.177,7.553,19.287.121.188.22.343.293.459.521.831,2.347,2.069,8.082,3.245a8.619,8.619,0,0,0,4.727-.383c.2-.163,2.452-2.207,4.209-11.675,1.31-7.058.472-16.04-4.35-20.2-3.348-2.884-8.219-3.255-14.48-1.1",
    transform: "translate(-63.163 -1.341)",
    fill: "#333533"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10379",
    "data-name": "Path 10379",
    d: "M175.416,31.016s-1.07-4.464.884-4.882,2.627.3,3.254,1.488.233,3.626.233,3.626l2.882.093s0-3.556.977-5.021,3.487-2.162,4.533-4.673a29.184,29.184,0,0,0,1.465-4.394s-15.762,6-16.529,6.625-.976.628-.976.628Z",
    transform: "translate(-62.543 -6.269)",
    fill: "#333533"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10380",
    "data-name": "Path 10380",
    d: "M170.046,25.126l-1.993-2.361c.4-.339,10.052-8.3,30.837-9.359l.157,3.085c-19.755,1.008-28.911,8.558-29,8.635",
    transform: "translate(-61.058 -4.871)",
    fill: "#fd734e"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10381",
    "data-name": "Path 10381",
    d: "M170.052,17.4s-3.69-5.929,3.348-13.112c6.765-6.9,21.341-5.789,24.27,5.649A68.069,68.069,0,0,0,170.052,17.4",
    transform: "translate(-61.434 0)",
    fill: "#fd734e"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10382",
    "data-name": "Path 10382",
    d: "M179.452,36.971c-1.946-1.616-2.848-3.085-2.68-4.369a2.645,2.645,0,0,1,1.446-1.914l.259.562-.13-.281.131.28a2.05,2.05,0,0,0-1.093,1.44c-.133,1.043.718,2.36,2.462,3.807Z",
    transform: "translate(-64.219 -11.149)",
    fill: "#333533"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10383",
    "data-name": "Path 10383",
    d: "M180.989,35.946a5.279,5.279,0,0,1-1.9-2.436l.581-.211a4.721,4.721,0,0,0,1.639,2.121Z",
    transform: "translate(-65.07 -12.098)",
    fill: "#333533"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10384",
    "data-name": "Path 10384",
    d: "M199.047,35.408c0,.629-.312,1.139-.7,1.139s-.7-.51-.7-1.139.313-1.139.7-1.139.7.51.7,1.139",
    transform: "translate(-71.813 -12.451)",
    fill: "#333533"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10385",
    "data-name": "Path 10385",
    d: "M212.48,34.678c0,.629-.26,1.139-.581,1.139s-.581-.51-.581-1.139.26-1.139.581-1.139.581.51.581,1.139",
    transform: "translate(-76.777 -12.186)",
    fill: "#333533"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10386",
    "data-name": "Path 10386",
    d: "M195.131,32.86l-.463-.409a3.686,3.686,0,0,1,5.216-.222l-.39.48a3.031,3.031,0,0,0-4.362.15",
    transform: "translate(-70.728 -11.349)",
    fill: "#333533"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10387",
    "data-name": "Path 10387",
    d: "M208.929,31.909l-.442-.432a2.8,2.8,0,0,1,3.961-.247l-.413.46a2.239,2.239,0,0,0-3.106.218",
    transform: "translate(-75.749 -11.084)",
    fill: "#333533"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M170.133,21.768l-.353-.507c.124-.087,12.606-8.626,27.946-8.006l-.025.618c-15.129-.614-27.446,7.81-27.569,7.9",
    transform: "translate(-61.686 -4.804)",
    fill: "#333533"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M195.083,9.819C191.594.762,181.363,2.8,180.929,2.9l-.128-.6c.111-.024,11.18-2.246,14.859,7.3Z",
    transform: "translate(-65.69 -0.745)",
    fill: "#333533"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M188.49,56.226A13.483,13.483,0,0,0,200.4,59.914l-1.021-1.758s-7.091.113-10.892-1.929",
    transform: "translate(-68.484 -20.428)",
    fill: "#333533"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M145.965,172.865,141.71,298.184l3.234,5.1,16.339,1.307,4.255-4.709,8.509-84.416.171-10.949,2.723-30.294Z",
    transform: "translate(-51.487 -62.807)",
    fill: "#6a7fdb"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    "data-name": "Path 10392",
    d: "M161.245,304.692l-16.557-1.324-3.33-5.255,0-.069L145.623,172.5l.223.01,31.207,1.371-2.744,30.526-.169,10.933-8.519,84.507Zm-16.3-1.749,16.119,1.289,4.133-4.573,8.5-84.344.169-10.93,2.7-30.08-30.52-1.341L141.806,297.99Z",
    transform: "translate(-51.359 -62.674)",
    fill: "#333533"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M271.237,154.9l19.885-2.957-.85-3.54-23.223,2.691.283,4.532Z",
    transform: "translate(-97.027 -53.919)",
    fill: "#333533"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M150.175,136.58s4.538-55.73,9.3-67.3l5.673-1.588s8.623,7.715,16.792,8.169,9.077-8.85,9.077-8.85l5.673,3.176a145.721,145.721,0,0,1,5.446,35.628c.454,19.515-.454,30.408-.454,30.408s-37.9,11.158-51.512.36",
    transform: "translate(-54.563 -24.346)",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M169.053,141.29c-7.329,0-14.6-1.133-19.148-4.742l-.093-.074.01-.118c.045-.558,4.6-55.9,9.32-67.369l.041-.1,5.895-1.65.09.081c.086.076,8.661,7.669,16.657,8.113,7.862.441,8.835-8.559,8.844-8.65l.032-.339,6.048,3.386.026.085a147.3,147.3,0,0,1,5.456,35.687c.449,19.3-.446,30.323-.455,30.432l-.012.152-.146.043a151.484,151.484,0,0,1-20.684,4.236,94.318,94.318,0,0,1-11.88.826m-18.779-5.017c13.021,10.145,48.482.308,51.071-.43.105-1.391.861-12.181.441-30.232a147.226,147.226,0,0,0-5.411-35.482l-5.311-2.975c-.267,1.678-1.873,9.129-9.264,8.719-7.7-.428-15.879-7.317-16.836-8.145l-5.452,1.527c-4.578,11.365-9,64.133-9.237,67.017",
    transform: "translate(-54.431 -24.14)",
    fill: "#333533"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10396",
    "data-name": "Path 10396",
    d: "M223.242,72s10.268,7.319,14.863,19.232,5.617,18.041,5.617,18.041L228.4,113.7Z",
    transform: "translate(-81.11 -26.159)",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M228.054,113.71l-.032-.258-5.225-42.2.411.294c.1.073,10.375,7.494,14.942,19.333,4.551,11.8,5.618,18.022,5.628,18.084l.032.195-.19.055Zm-4.689-41.49,5.066,40.919,14.874-4.3c-.216-1.135-1.482-7.206-5.568-17.8-4-10.359-12.411-17.3-14.372-18.819",
    transform: "translate(-80.949 -25.888)",
    fill: "#333533"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M164.219,114.369v.039c-.006,22.232-3.858,50.224-3.858,50.224l-25.871-5.1s.227-36.877,3.461-49.811,15.829-40.052,15.829-40.052l5.674-1.589s2.645,13.361,4,29.375c.161,1.914.3,3.863.419,5.834q.159,2.634.25,5.3c.064,1.93.1,3.866.1,5.787",
    transform: "translate(-48.864 -24.734)",
    fill: "#333533"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10399",
    "data-name": "Path 10399",
    d: "M166.624,131.7c.064,1.93.1,3.866.1,5.787v.039l-25.338,1.694,3.4-6.231Z",
    transform: "translate(-51.37 -47.85)",
    fill: "#fd734e"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M167.491,114.215c.161,1.913.3,3.862.419,5.834l-22.3,1.489,3.4-6.23Z",
    transform: "translate(-52.905 -41.498)",
    fill: "#fd734e"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M120.643,128.175s-3.971,11.176,1.135,17.189,26.777,13.389,29.046,14.75,5.446,3.176,5.446,3.176L160.7,156.6s-7.489-8.736-11.233-12.141-6.354-6.24-6.354-6.24l.341-1.191s-17.7-14.58-22.806-8.85",
    transform: "translate(-43.299 -46.085)",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10402",
    "data-name": "Path 10402",
    d: "M156.2,163.46l-.181-.1c-.031-.018-3.206-1.832-5.451-3.18-.556-.334-2.338-1.05-4.8-2.041-7.145-2.871-20.444-8.216-24.3-12.756-5.13-6.041-1.338-16.946-1.174-17.408l.014-.041.029-.032c5.188-5.823,22.384,8.226,23.113,8.827l.112.092-.346,1.211c.477.512,2.933,3.115,6.255,6.135,3.712,3.374,11.177,12.073,11.252,12.16l.109.127Zm-35.5-35.3c-.253.744-3.7,11.265,1.108,16.931,3.785,4.457,17.016,9.774,24.125,12.631,2.485,1,4.28,1.72,4.866,2.072,1.933,1.16,4.557,2.667,5.262,3.071l4.217-6.38c-.937-1.089-7.658-8.861-11.1-11.994-3.709-3.372-6.341-6.226-6.367-6.254l-.084-.092.334-1.17c-1.511-1.219-17.619-14-22.357-8.815",
    transform: "translate(-43.161 -45.957)",
    fill: "#333533"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M149.054,70.572s-19.061,4.652-27.571,37.159l22.806,8.85s6.978-23.26,4.765-46.009",
    transform: "translate(-44.138 -25.641)",
    fill: "#fff"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M144.282,116.717l-23.215-9.009.05-.192c4.41-16.845,11.7-26.09,17.043-30.879,5.8-5.2,10.642-6.428,10.69-6.439l.249-.061.025.255c2.191,22.532-4.7,45.861-4.774,46.094ZM121.6,107.437l22.395,8.691c.708-2.474,6.7-24.267,4.715-45.427a29,29,0,0,0-10.275,6.29c-5.267,4.73-12.453,13.849-16.835,30.446",
    transform: "translate(-43.987 -25.483)",
    fill: "#333533"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M215.692,149.381c1.1-6.891,1.09-21.711.682-36.9-.05-1.88-.105-3.768-.166-5.646-.058-1.839-.125-3.672-.191-5.48-.073-1.919-.147-3.813-.222-5.666-.66-15.8-1.464-28.676-1.464-28.676L220,70.186c2.119,6.417,3.91,15.35,5.4,24.931.283,1.83.555,3.685.818,5.552.258,1.836.5,3.683.74,5.526s.463,3.694.679,5.527c2.38,20.161,3.483,38.569,3.483,38.569Z",
    transform: "translate(-77.872 -24.346)",
    fill: "#333533"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M176.907,173.709,195.4,121.46l11.914-3.915s6.978,2.553,9.871,1.362a72.264,72.264,0,0,0,8.34-4.765l6.127-.17,3.574-2.723,10.382-8.51-19.062,66.886-4.425-.511-6.808,2.894-4.425-.851-8.339,4.765-7.659-2.212Z",
    transform: "translate(-64.275 -37.328)",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M202.4,175.806l-.09-.026-7.629-2.2H176.412l18.636-52.649.1-.034,11.987-3.938.073.026c.069.025,6.93,2.51,9.71,1.365a72.385,72.385,0,0,0,8.3-4.746l.053-.034,6.118-.17,3.517-2.68,10.925-8.955-19.308,67.75-4.554-.525-6.816,2.9-4.41-.849Zm-25.357-2.674h17.7l7.6,2.2,8.33-4.76,4.439.854,6.8-2.89,4.3.5,18.816-66.021-9.833,8.06-3.637,2.771-6.136.17a71.358,71.358,0,0,1-8.324,4.751c-2.812,1.157-9.164-1.047-9.959-1.333l-11.738,3.857Z",
    transform: "translate(-64.095 -36.973)",
    fill: "#333533"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M150,143.354c-4.663-2.442-11.515-2.471-11.584-2.471v-.444c.07,0,7.031.029,11.79,2.521Z",
    transform: "translate(-50.289 -51.025)",
    fill: "#333533"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M196.206,177.2l-3.858.227-2.419-.7c-.009-.05-.019-.1-.029-.147a21.927,21.927,0,0,0,3.525-.08c1.957-.255,4.2-1.088,4.557-2.061.152-.416-2.761.075-2.761.075l-4.009-.057-3.167-.609a18.8,18.8,0,0,0-2.664-.738c.1-.02.157-.044.157-.071,0-.227.908-1.249.908-1.249l.34-1.248a25.438,25.438,0,0,0-2.609.681,10.606,10.606,0,0,0-2.383,1.248s-5.417,5.02-4.425,6.694c.813,1.371,9.241,4.662,9.241,4.662s2.489-.081,4.261-.313,4.008-.451,4.236-1.361c.114-.454-2.591-.038-2.591-.038L189.253,182a5.409,5.409,0,0,0,.246-.485,22.555,22.555,0,0,0,3.7-.071c1.958-.255,4.3-.91,4.482-1.928.076-.416-3.1.264-3.1.264l-3.537-.038-1.025-.138c.015-.116.027-.232.038-.347a25.317,25.317,0,0,0,4.448-.025c1.957-.255,4.36-1.2,4.595-2.212.132-.567-2.893.189-2.893.189",
    transform: "translate(-64.4 -61.965)",
    fill: "#fff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10410",
    "data-name": "Path 10410",
    d: "M186.466,183.888l-.038-.015c-.87-.339-8.516-3.357-9.341-4.748-1.045-1.762,3.895-6.419,4.461-6.944A10.572,10.572,0,0,1,184,170.889a26.1,26.1,0,0,1,2.634-.688l.32-.064-.439,1.608-.031.035a8.247,8.247,0,0,0-.83,1.065,17.259,17.259,0,0,1,2.334.665l3.132.6,3.973.056c1.737-.292,2.719-.319,2.92-.078a.272.272,0,0,1,.046.272c-.391,1.075-2.724,1.932-4.721,2.192a18.338,18.338,0,0,1-2.5.112l1.422.412,3.8-.224c.989-.246,2.677-.6,3.034-.25a.32.32,0,0,1,.086.307c-.286,1.227-3.013,2.138-4.766,2.366a22.8,22.8,0,0,1-3.755.071l.3.04,3.489.036c1.322-.283,2.948-.556,3.241-.272a.268.268,0,0,1,.079.244c-.263,1.448-3.923,2-4.653,2.093a22.265,22.265,0,0,1-3.6.079l-.043.089,2.926.111c.9-.138,2.43-.316,2.728.012a.3.3,0,0,1,.07.276c-.245.981-2.172,1.227-4.035,1.465l-.371.048c-1.762.23-4.256.315-4.281.315Zm-.069-13.223c-.485.107-1.436.33-2.265.606a10.478,10.478,0,0,0-2.329,1.221c-1.454,1.35-5.115,5.17-4.369,6.428.634,1.069,6.747,3.64,9.1,4.563.331-.012,2.582-.1,4.2-.311l.372-.048c1.431-.183,3.372-.431,3.669-1.089a8.973,8.973,0,0,0-2.338.136l-.019,0H192.4l-3.6-.138.165-.288c.085-.148.164-.306.236-.467l.056-.126.138.007a22.354,22.354,0,0,0,3.664-.069c2.288-.3,4-.969,4.278-1.659a13.939,13.939,0,0,0-2.83.391l-.022,0-3.558-.038-1.249-.167.025-.2c.015-.113.027-.226.037-.339l.018-.2.2.015a25.054,25.054,0,0,0,4.408-.024c1.879-.246,4.124-1.145,4.409-2a8.962,8.962,0,0,0-2.633.374l-.037.006-3.892.229-2.57-.744-.1-.519.259.011a21.782,21.782,0,0,0,3.49-.078c2.034-.266,3.917-1.063,4.341-1.816a12.373,12.373,0,0,0-2.485.229l-.018,0-4.063-.06-3.2-.619a18.27,18.27,0,0,0-2.633-.728l-.949-.2.952-.189.025-.006a5.324,5.324,0,0,1,.9-1.215Z",
    transform: "translate(-64.288 -61.816)",
    fill: "#333533"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M257.1,162.5l2.625.227,1.646-.7c.006-.05.013-.1.02-.147a10.177,10.177,0,0,1-2.4-.08c-1.332-.255-2.861-1.088-3.1-2.061-.1-.416,1.879.075,1.879.075l2.728-.057,2.155-.609c.479-.275.442-.485,1.107-.7-.068-.02.153-2.5.965-2.1a19.41,19.41,0,0,1,2.182,1.419s1.443,5.871.768,7.545c-.553,1.37-4.045,3.811-4.045,3.811a25.36,25.36,0,0,1-2.9-.313c-1.207-.231-2.728-.451-2.883-1.361-.077-.454,1.763-.038,1.763-.038l2.223-.125q-.092-.236-.167-.485a10.469,10.469,0,0,1-2.518-.071c-1.332-.255-2.924-.91-3.05-1.928-.051-.416,2.111.264,2.111.264l2.407-.038.7-.138c-.01-.116-.019-.232-.026-.347a11.747,11.747,0,0,1-3.027-.025c-1.332-.255-2.967-1.2-3.127-2.212-.09-.567,1.969.189,1.969.189",
    transform: "translate(-92.696 -56.793)",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M263.584,169.205l-.057,0a25.835,25.835,0,0,1-2.923-.316l-.25-.047c-1.219-.229-2.6-.488-2.765-1.45a.291.291,0,0,1,.088-.267c.291-.276,1.375-.073,1.853.034l1.975-.111c-.018-.052-.036-.1-.053-.157a10.272,10.272,0,0,1-2.43-.083c-1.45-.278-3.047-.968-3.183-2.072a.253.253,0,0,1,.09-.231c.289-.241,1.5.086,2.209.309l2.365-.038.538-.107c0-.01,0-.02,0-.03a11.461,11.461,0,0,1-2.9-.045c-1.438-.276-3.091-1.285-3.26-2.35a.312.312,0,0,1,.107-.3c.342-.28,1.539.11,2.062.3l2.562.222,1.14-.485a9,9,0,0,1-1.878-.11c-1.369-.262-2.967-1.117-3.231-2.184a.26.26,0,0,1,.067-.253c.257-.257,1.347-.037,1.991.122l2.685-.055,2.114-.6a1.943,1.943,0,0,0,.35-.264,1.712,1.712,0,0,1,.648-.393c.01-.437.174-1.716.659-2.083a.507.507,0,0,1,.553-.049,19.19,19.19,0,0,1,2.208,1.434l.048.036.014.058c.06.242,1.448,5.943.761,7.647-.565,1.4-3.959,3.784-4.1,3.886Zm-5.664-1.852c.144.719,1.392.952,2.5,1.159l.251.048a24.959,24.959,0,0,0,2.82.308c.413-.293,3.445-2.479,3.94-3.7.613-1.519-.614-6.773-.761-7.385a18.554,18.554,0,0,0-2.108-1.367.175.175,0,0,0-.2.012c-.355.258-.528,1.447-.535,1.81l.413.122-.516.164a1.466,1.466,0,0,0-.652.367,2.284,2.284,0,0,1-.423.314l-.038.016-2.2.616-2.75.057-.022-.006a5.482,5.482,0,0,0-1.664-.225c.264.878,1.7,1.645,2.957,1.887a10.06,10.06,0,0,0,2.357.076l.2-.013-.06.442-1.771.754-2.71-.241a3.877,3.877,0,0,0-1.758-.364c.155.905,1.7,1.82,3,2.069a11.537,11.537,0,0,0,2.978.023l.173-.018.011.174q.01.171.025.342l.013.148-.874.171-2.433.038-.026-.008a6.792,6.792,0,0,0-1.887-.388c.16.841,1.562,1.473,2.908,1.731a10.281,10.281,0,0,0,2.475.068l.132-.01.039.127c.05.164.1.323.163.474l.083.213-2.474.139-.022-.006a3.926,3.926,0,0,0-1.559-.132",
    transform: "translate(-92.601 -56.699)",
    fill: "#333533"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17373",
    "data-name": "Rectangle 17373",
    width: 57.521,
    height: 0.444,
    transform: "translate(130.385 136.33) rotate(-77.498)",
    fill: "#333533"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17374",
    "data-name": "Rectangle 17374",
    width: 51.893,
    height: 0.445,
    transform: "translate(146.898 133.123) rotate(-83.587)",
    fill: "#333533"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10413",
    "data-name": "Path 10413",
    d: "M237.325,178.531l-.437-.078L247.1,120.588l.437.078Z",
    transform: "translate(-86.068 -43.813)",
    fill: "#333533"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10414",
    "data-name": "Path 10414",
    d: "M146.789,377.716l2.723,11.973-1.7,15.317h25.756a16.109,16.109,0,0,0-6.066-11.6l-4.259-3.378-.114-11.006Z",
    transform: "translate(-53.333 -137.235)",
    fill: "#333533"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17375",
    "data-name": "Rectangle 17375",
    width: 55.96,
    height: 0.445,
    transform: "translate(157.624 131.748) rotate(-80.187)",
    fill: "#333533"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10415",
    "data-name": "Path 10415",
    d: "M121.07,130.521l22.657,8.025.411-.76-22.806-8.85Z",
    transform: "translate(-43.988 -46.846)",
    fill: "#333533"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M227.057,116.709l-10.205.682c-.072-1.919-.147-3.812-.222-5.665l9.609-.569c.283,1.83.555,3.686.818,5.552",
    transform: "translate(-78.708 -40.386)",
    fill: "#fd734e"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M138.724,195.165l-.04-.442c.115-.011,11.6-1.212,16.379-14.3l.418.152c-4.878,13.359-16.638,14.578-16.757,14.589",
    transform: "translate(-50.388 -65.553)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17376",
    "data-name": "Rectangle 17376",
    width: 90.55,
    height: 0.445,
    transform: "translate(94.055 231.551) rotate(-87.867)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17377",
    "data-name": "Rectangle 17377",
    width: 0.444,
    height: 79.145,
    transform: "matrix(0.993, -0.118, 0.118, 0.993, 125.904, 154.268)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M279.727,217.726l.283-34.552,2.337-4.956-.213-21.029Z",
    transform: "translate(-101.633 -57.111)",
    fill: "#ffd447"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M279.822,217.726l-.444,0,.284-34.6L282,178.168l-.211-20.978.443,0,.213,21.079-2.338,4.958Z",
    transform: "translate(-101.506 -57.11)",
    fill: "#333533"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M305.064,94.35l-4.429-5.777,12.178,4.815Z",
    transform: "translate(-109.229 -32.181)",
    fill: "#333533"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17378",
    "data-name": "Rectangle 17378",
    width: 0.444,
    height: 89.993,
    transform: "translate(152.101 146.19) rotate(-5.1)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17379",
    "data-name": "Rectangle 17379",
    width: 0.445,
    height: 77.439,
    transform: "translate(181.135 156.629) rotate(-13.16)",
    fill: "#fff"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M286.562,96.394l5.381-.661-.567-4.343-5.57.661Z",
    transform: "translate(-103.842 -33.205)",
    fill: "#ffd447"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10422",
    "data-name": "Path 10422",
    d: "M286.232,96.5l-.832-4.781,6.02-.714.623,4.781Zm-.314-4.4.679,3.9,4.95-.608-.509-3.9Z",
    transform: "translate(-103.694 -33.065)",
    fill: "#333533"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10423",
    "data-name": "Path 10423",
    d: "M268.39,9.665c-.909-6.087-8.238-7.719-8.313-7.734l.1-.46c.077.017,7.724,1.713,8.68,8.125Z",
    transform: "translate(-94.493 -0.534)",
    fill: "#333533"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10424",
    "data-name": "Path 10424",
    d: "M421.587,57.523s2.266-.472,5.861-1.62c3.828-1.222-5.861,1.62-5.861,1.62",
    transform: "translate(-153.174 -20.2)",
    fill: "#fff"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10425",
    "data-name": "Path 10425",
    d: "M421.606,57.8l-.092-.443c.023,0,2.3-.483,5.839-1.614l.138.431c-3.565,1.138-5.861,1.621-5.884,1.626",
    transform: "translate(-153.148 -20.251)",
    fill: "#333533"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    "data-name": "Path 10426",
    d: "M422.032,54.176s4.673-.9,6.278-2.077-6.278,2.077-6.278,2.077",
    transform: "translate(-153.336 -18.835)",
    fill: "#fff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    "data-name": "Path 10427",
    d: "M422.05,54.441,421.965,54c.047-.009,4.641-.9,6.187-2.037l.268.364c-1.627,1.2-6.176,2.08-6.369,2.117",
    transform: "translate(-153.312 -18.879)",
    fill: "#333533"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPeople);
export default __webpack_public_path__ + "static/media/hero_people.5da90efe90fad1bc6947fb97b0f41913.svg";
export { ForwardRef as ReactComponent };